import React, { FC } from "react";
import { checkImage, getHexColor, imgCrop } from "../../helpers";
import "./index.scss";

interface Props {
  title: string;
  subtitle?: string;
  backgroundImage: imgCrop[];
  logoImage?: imgCrop[];
  buttonTextColor: string;
  buttonColor: string;
  buttonLink: string;
  buttonText: string;
  buttonTarget: string;
}

const HomeCTA: FC<Props> = ({
  logoImage,
  backgroundImage,
  buttonColor,
  buttonTextColor,
  buttonTarget,
  buttonText,
  buttonLink,
  title,
  subtitle
}) => {
  const schemaColors: Record<string, string> = {
    "--cta-buttonColor": buttonColor
      ? getHexColor(buttonColor)
      : "var(--color-yellow)",
    "--cta-buttonTextColor": buttonTextColor
      ? getHexColor(buttonTextColor)
      : "var(--color-black)"
  };

  return (
    <a
      className="home-cta"
      style={{
        ...schemaColors,
        backgroundImage: `url("${process.env.HOST}${checkImage({
          images: backgroundImage,
          size: "Medium"
        })}")`.replace("&height=416", "&height=512")
      }}
      href={buttonLink}
      target={buttonTarget}
    >
      <div className="home-cta__details">
        {logoImage && (
          <div
            style={{
              backgroundImage: `url("${process.env.HOST}${checkImage({
                images: logoImage,
                size: "Medium"
              })}")`
            }}
            className="home-cta__logo"
          />
        )}
        <div className="home-cta__title">{title}</div>
        {subtitle && <div className="home-cta__sub-title">{subtitle}</div>}
      </div>
      {buttonText && buttonText.length > 0 ? (
        <div className="home-cta__btn">{buttonText}</div>
      ) : null}
    </a>
  );
};

export default HomeCTA;
